import React, { useEffect, useState } from "react";
import Recent from "../Notifications/Recent";
import Allocated from "../Notifications/Allocated";
import Closed from "../Notifications/Closed";
import { post } from "../../Services/ApiHandler";
import { URL } from "../../Services/Constant";
import moment from "moment/moment";

const OverallNotification = () => {
  const [activeTab, setActiveTab] = useState(1);
  const [sites, setSites] = useState(null);
  const [companies, setCompanies] = useState(null);
  const [comapanyList, setCompanyList] = useState([]);
  const [siteList, setSiteList] = useState([]);
  const [selectedItem, setSelectedItem] = useState({});
  const [page, setPage] = useState(1);
  const [pagination, setPagination] = useState("");
  const [list, setList] = useState([]);
  const [typeDrop, setTypeDrop] = useState(null);
  const [cam, setCam] = useState(null);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [searchText, setSearchText] = useState("");

  // useEffect(() => {
  //   const stored = localStorage.getItem("Notifications");
  //   if (stored) {
  //     setActiveTab(JSON.parse(stored));
  //   } else {
  //     setActiveTab(1);
  //     localStorage.setItem("Notifications", JSON.stringify(1));
  //   }
  // }, []);

  const handleTab = (type) => {
    setActiveTab(type);
    setPage(1);
    getNotification("", "", "", "", "", "", 1, sites, type);
    localStorage.setItem("Notifications", JSON.stringify(type));
  };

  const getCompanyList = () => {
    post(URL.COMPANY_LIST_ADMIN, {})
      .then((res) => {
        setCompanyList(res?.companies);
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const getSiteList = (company_id) => {
    if (company_id?.value) {
      setCompanies(company_id);
      let formdata = new FormData();
      formdata.append("company_id", company_id?.value);
      post(URL.ACTIVE_ADMIN_SITE, formdata)
        .then((res) => {
          if (res?.sites?.length > 0) {
            setSiteList(res?.sites);
          } else {
            setSiteList([]);
          }
        })
        .catch((err) => {
          console.log("err", err);
        });
    } else {
      setCompanies(null);
      setSiteList([]);
      setSites("");
      setList([]);
      setPagination("");
    }
  };

  useEffect(() => {
    getCompanyList();
  }, []);

  const getNotification = (
    from_date,
    to_date,
    search_value,
    type_value,
    camera_id,
    severity_type,
    page_no,
    site_id,
    tab_type
  ) => {
    if (site_id?.value) {
      let formdata = new FormData();
      formdata.append("page", page_no);
      formdata.append("type", tab_type ? tab_type : activeTab);
      formdata.append("site_id", site_id?.value);
      setSites(site_id);

      if (camera_id?.value) {
        formdata.append("camera_id", camera_id?.value);
      }
      if (from_date) {
        formdata.append("from_date", moment(from_date).format("DD-MM-YYYY"));
      }
      if (to_date) {
        formdata.append("to_date", moment(to_date).format("DD-MM-YYYY"));
      }
      if (type_value?.value) {
        formdata.append("alert_id", type_value?.value);
      }

      //   if (severity_type?.value) {
      //     formdata.append("severity", severity_type?.value);
      //   }

      if (search_value) {
        formdata.append("search", search_value);
      }

      setSearchText(search_value);
      setFromDate(from_date);
      setToDate(to_date);
      setCam(camera_id);
      setTypeDrop(type_value);
      post(URL.ADMIN_NOTIFICATION, formdata)
        .then((res) => {
          if (res?.status == "success") {
            setList(res?.lists);
            setPagination(res?.pagination_meta);
          }
        })
        .catch((err) => {
          console.log("err", err);
        });
    } else {
      setList([]);
      setSites("");
      setPagination("");
    }
  };

  return (
    <div className="dashRightView">
      <div className="tab-header d-flex gap-3 mb-3">
        <button
          className={`tab-btn ${activeTab == 1 ? "active" : ""}`}
          onClick={() => handleTab(1)}
        >
          New
        </button>
        <button
          className={`tab-btn ${activeTab == 3 ? "active" : ""}`}
          onClick={() => handleTab(3)}
        >
          Assigned
        </button>
        <button
          className={`tab-btn ${activeTab == 5 ? "active" : ""}`}
          onClick={() => handleTab(5)}
        >
          Closed
        </button>
      </div>

      <div>
        {activeTab == 1 && (
          <Recent
            site={"admin"}
            sites={sites}
            setSites={(val) =>
              getNotification(
                fromDate,
                toDate,
                searchText,
                typeDrop,
                cam,
                sites,
                page,
                val
              )
            }
            getNotification={getNotification}
            siteList={siteList}
            setSiteList={setSiteList}
            comapanyList={comapanyList}
            companies={companies}
            setCompanies={getSiteList}
            page={page}
            setPage={setPage}
            pagination={pagination}
            setPagination={setPagination}
            list={list}
            setList={setList}
            typeDrop={typeDrop}
            setTypeDrop={setTypeDrop}
            cam={cam}
            setCam={setCam}
            fromDate={fromDate}
            setFromDate={setFromDate}
            toDate={toDate}
            setToDate={setToDate}
            searchText={searchText}
            setSearchText={setSearchText}
          />
        )}
        {activeTab == 3 && (
          <Allocated
            site={"admin"}
            sites={sites}
            setSites={(val) =>
              getNotification(
                fromDate,
                toDate,
                searchText,
                typeDrop,
                cam,
                sites,
                page,
                val
              )
            }
            getNotification={getNotification}
            siteList={siteList}
            setSiteList={setSiteList}
            comapanyList={comapanyList}
            companies={companies}
            setCompanies={getSiteList}
            page={page}
            setPage={setPage}
            pagination={pagination}
            setPagination={setPagination}
            list={list}
            setList={setList}
            typeDrop={typeDrop}
            setTypeDrop={setTypeDrop}
            cam={cam}
            setCam={setCam}
            fromDate={fromDate}
            setFromDate={setFromDate}
            toDate={toDate}
            setToDate={setToDate}
            searchText={searchText}
            setSearchText={setSearchText}
          />
        )}
        {activeTab == 5 && (
          <Closed
            site={"admin"}
            sites={sites}
            setSites={(val) =>
              getNotification(
                fromDate,
                toDate,
                searchText,
                typeDrop,
                cam,
                sites,
                page,
                val
              )
            }
            getNotification={getNotification}
            siteList={siteList}
            setSiteList={setSiteList}
            comapanyList={comapanyList}
            companies={companies}
            setCompanies={getSiteList}
            page={page}
            setPage={setPage}
            pagination={pagination}
            setPagination={setPagination}
            list={list}
            setList={setList}
            typeDrop={typeDrop}
            setTypeDrop={setTypeDrop}
            cam={cam}
            setCam={setCam}
            fromDate={fromDate}
            setFromDate={setFromDate}
            toDate={toDate}
            setToDate={setToDate}
            searchText={searchText}
            setSearchText={setSearchText}
          />
        )}
      </div>
    </div>
  );
};

export default OverallNotification;
